/**
 * 69.52 step 4 (DECISIONS 262 (d), the owner: "we'll probably want it eventually so might as well build it while ships are
 * infinite to understand it"): when a side's ship is called **hot** (straight in, pressing on under fire: no bend round the
 * cover, no break-off) — the side trails on points by HOT_CALL.trailing or more and the cover it knows of stands over the
 * landing or across the straight way in from its ship base (core/skyRoute.ts): a drop that would be bent away or turned back
 * where it is wanted most. In core (69.37 step 4) so a play's air element asks it as the bot commander's fetch does
 * (ai/dropRules.ts). Pure; on the side's knowledge (the mounts it has seen).
 */
import type { GameState, Vec3 } from '../types';
import { vecDot, vecNormalize } from '../math';
import { dacos } from './dmath';
import { shipBase } from './dropship';
import { coverDiscs, trackCrossesCover, pilotRisk } from './skyRoute';
import { pointsHeld } from './capturePoints';

/** The points behind the most-holding enemy a side is when its drop is called hot. */
export const HOT_CALL = { trailing: 1 };

/** Is the side's drop at `at` wanted hot — it trails on points (the most-holding enemy HOT_CALL.trailing or more ahead) and the cover it knows of stands over the landing or across the straight way in from its ship base? */
export function hotWanted(state: GameState, team: number, at: { planetIndex: number; surfaceDir: Vec3 }): boolean {
  const held = pointsHeld(state.modeState.points), mine = held.get(team) ?? 0;
  const ahead = Math.max(0, ...[...held].filter(([t]) => t !== team).map(([, n]) => n));
  if (ahead - mine < HOT_CALL.trailing) return false;
  const discs = coverDiscs(state, team, at.planetIndex, pilotRisk(state.config, team));
  if (!discs.length) return false;
  const land = vecNormalize(at.surfaceDir), base = shipBase(state, team);
  if (discs.some(k => dacos(Math.max(-1, Math.min(1, vecDot(k.c, land)))) <= k.rho)) return true;
  return !!base && base.planetIndex === at.planetIndex && trackCrossesCover(base.surfaceDir, land, discs);
}
